module.exports = __webpack_public_path__ + "img/transaction.ded0f971.svg";